<template lang="pug">
v-row.mt-4
  v-col(md="4", offset-md="8")
    div(v-if="!isEdit")
      v-btn(text, @click="isEdit = true") edit
      v-btn.ml-4(color="primary", @click="downloadPDF") download pdf
    div(v-else)
      v-btn(text, @click="cancel") cancel
      v-btn.ml-4(color="primary", @click="save") save

  v-col(md="12")
    div(v-if="!isEdit", v-html="letter")
    quill-editor(v-else, v-model="letter")

  v-col(md="12")
    v-card.mt-4(v-if="decision")
      v-card-title Do you approve Cover letter?
      v-card-text 
        v-chip(
          v-if="decision.Valid",
          :color="decision.Bool ? 'green' : 'red'",
          text-color="white"
        ) {{ decision.Bool ? 'Approved' : 'Rejected' }}
        .d-flex.justify-space-around.pa-4(v-else)
          v-btn(color="error", @click="reject", :loading="isRejectLoading") reject
          v-btn(color="success", @click="approve", :loading="isApproveLoading") approve
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import { expertAPI } from "@/utils/apiUrls";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import Quill from "quill";
// import { jsPDF } from "jspdf"
var BackgroundStyle = Quill.import("attributors/style/background");
var alignStyle = Quill.import("attributors/style/align");
var ColorStyle = Quill.import("attributors/style/color");
var SizeStyle = Quill.import("attributors/style/size");
Quill.register(BackgroundStyle, true);
Quill.register(ColorStyle, true);
Quill.register(SizeStyle, true);
Quill.register(alignStyle, true);

export default {
  name: "expert-case-company-profile",

  components: {
    quillEditor,
  },

  data: () => ({
    letterInit: null,
    letter: null,
    isEdit: false,
    isRejectLoading: false,
    isApproveLoading: false,
  }),

  computed: {
    decision() {
      return this.$store.state.expert.usercase.usercase?.cover_letter_review;
    },

    usercase() {
      return this.$store.state.expert.usercase.usercase;
    },
  },

  mounted() {
    this.getCoverLetter();
  },

  methods: {
    approve() {
      this.isApproveLoading = true;
      this.axios
        .get(
          expertAPI.usercase.sponsorship.decision.ApproveCoverLetterURL(
            this.usercase.ID
          )
        )
        .then(() => this.$store.dispatch("expert/usercase/refreshUsercase"))
        .finally(() => (this.isApproveLoading = false));
    },

    reject() {
      this.axios
        .get(
          expertAPI.usercase.sponsorship.decision.RejectCoverLetterURL(
            this.usercase.ID
          )
        )
        .then(() => this.$store.dispatch("expert/usercase/refreshUsercase"))
        .finally(() => (this.isApproveLoading = false));
    },

    cancel() {
      this.letter = this.letterInit;
      this.isEdit = false;
    },

    save() {
      this.axios
        .put(
          expertAPI.usercase.sponsorship.UpdateCaseCoverLetterURL(
            this.$route.params.case_id
          ),
          {
            letter: this.letter,
          }
        )
        .then((resp) => {
          this.letterInit = resp.data;
          this.letter = resp.data;
          this.isEdit = false;
        });
    },

    downloadPDF() {
      this.axios
        .get(
          expertAPI.usercase.sponsorship.GetCaseCoverLetterURL(
            this.$route.params.case_id
          ) + "?pdf",
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          const type = response.headers["content-type"];
          const blob = new Blob([response.data], {
            type: type,
            encoding: "UTF-8",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "CoverLetter.pdf";
          link.click();
          link.remove();
        });
    },

    async getCoverLetter() {
      await this.axios
        .get(
          expertAPI.usercase.sponsorship.GetCaseCoverLetterURL(
            this.$route.params.case_id
          )
        )
        .then((resp) => {
          this.letterInit = resp.data;
          this.letter = resp.data;
        });
    },
  },
};
</script>